import chroma from "chroma-js";
/**
 * The colours that tell surveys apart in charts and pickers, the most distinct first. None of them is a
 * green, red, orange or grey: the insights charts use those for a verdict, a target and neutral answers.
 * Keep in step with `SurveyColorsV3` in the API, which hands out the first unused one to a new survey.
 */
export var SURVEY_COLORS = [
    '#2563EB',
    '#EC4899',
    '#5B2155',
    '#0EA5E9',
    '#A78BFA',
    '#7E22CE',
    '#155E75',
    '#1E3A8A',
];
/** `#RRGGBB` from what the colour picker stores (`#RRGGBBAA`); a survey colour is never transparent. */
export var toSurveyColor = function (value) {
    var match = value === null || value === void 0 ? void 0 : value.trim().match(/^#([0-9a-f]{6})([0-9a-f]{2})?$/i);
    return match ? "#".concat(match[1].toUpperCase()) : undefined;
};
/**
 * A survey's colour. A survey saved before surveys had colours gets a palette colour picked from its id, so
 * it looks the same on every screen until its next save stores one of its own.
 */
export var surveyColorOf = function (survey) {
    var _a;
    var own = toSurveyColor(survey.color);
    if (own)
        return own;
    var key = (_a = survey.id) !== null && _a !== void 0 ? _a : '';
    var hash = 0;
    for (var index = 0; index < key.length; index++) {
        hash = (hash * 31 + key.charCodeAt(index)) >>> 0;
    }
    return SURVEY_COLORS[hash % SURVEY_COLORS.length];
};
/** The colour the API gives a new survey: the first palette colour nobody uses, else the least used one. */
export var nextSurveyColor = function (used) {
    var counts = new Map();
    used.map(toSurveyColor).forEach(function (color) {
        var _a;
        if (color)
            counts.set(color, ((_a = counts.get(color)) !== null && _a !== void 0 ? _a : 0) + 1);
    });
    return SURVEY_COLORS.reduce(function (best, color) { var _a, _b; return (((_a = counts.get(color)) !== null && _a !== void 0 ? _a : 0) < ((_b = counts.get(best)) !== null && _b !== void 0 ? _b : 0) ? color : best); }, SURVEY_COLORS[0]);
};
/** A red, orange, green or grey - the colours the insights charts already use to judge a figure. */
export var isJudgingColor = function (color) {
    if (!chroma.valid(color))
        return false;
    var _a = chroma(color).hsl(), hue = _a[0], saturation = _a[1], lightness = _a[2];
    if (saturation < 0.25 || Number.isNaN(hue))
        return lightness > 0.15 && lightness < 0.9;
    var redOrOrange = hue < 50 || hue > 340;
    var green = hue >= 80 && hue <= 165;
    return redOrOrange || green;
};
